__turbopack_context__.v({
  "image": "TimelineGuide-module__mwLqrq__image",
  "left": "TimelineGuide-module__mwLqrq__left",
  "lineBackground": "TimelineGuide-module__mwLqrq__lineBackground",
  "lineProgress": "TimelineGuide-module__mwLqrq__lineProgress",
  "right": "TimelineGuide-module__mwLqrq__right",
  "step": "TimelineGuide-module__mwLqrq__step",
  "stepContent": "TimelineGuide-module__mwLqrq__stepContent",
  "stepDescription": "TimelineGuide-module__mwLqrq__stepDescription",
  "stepDualImages": "TimelineGuide-module__mwLqrq__stepDualImages",
  "stepImage": "TimelineGuide-module__mwLqrq__stepImage",
  "stepLink": "TimelineGuide-module__mwLqrq__stepLink",
  "stepNumber": "TimelineGuide-module__mwLqrq__stepNumber",
  "stepNumberShield": "TimelineGuide-module__mwLqrq__stepNumberShield",
  "stepNumberShieldHidden": "TimelineGuide-module__mwLqrq__stepNumberShieldHidden",
  "stepTitle": "TimelineGuide-module__mwLqrq__stepTitle",
  "timeline": "TimelineGuide-module__mwLqrq__timeline",
});
